// External deps

import dayjs from 'dayjs';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import PropTypes from 'prop-types';

// Internal deps
import useCalendar from '../../../../../hooks/useCalendar';
import Day from '../Day/Day';
import './Month.scss';

const Month = ({
  month,
  showActions,
  showHeader,
  onClickDayBefore,
  onClickNextDay,
  arrayDate,
  onClickDay,
  manualChange,
  minDate,
  maxDate,
  disabled,
  disabledEditStateCancelOrFinish,
  isSummaryModal,
  lineBlockedBySap
}) => {
  const { monthIndex, setMonthIndex, yearIndex } = useCalendar();

  const handleNextMonth = () => {
    if (manualChange) {
      onClickDayBefore();
    } else {
      setMonthIndex(monthIndex + 1);
    }
  };

  const handlePrevMonth = () => {
    if (manualChange) {
      onClickNextDay();
    } else {
      setMonthIndex(monthIndex - 1);
    }
  };

  return (
    <div className="month">
      {showHeader && (
        <div className="month-title">
          {showActions && (
            <div aria-hidden onClick={() => handlePrevMonth()}>
              <BsChevronLeft className="arrow" size={20} />
            </div>
          )}
          <div className="month-title-name">
            {dayjs(new Date(yearIndex, monthIndex)).format('MMMM YYYY').toUpperCase()}
          </div>
          {showActions && (
            <div aria-hidden onClick={() => handleNextMonth()}>
              <BsChevronRight className="arrow" size={20} />
            </div>
          )}
        </div>
      )}
      <div className="month-calendar">
        {month.map((row, idx) => (
          <div className="week" key={`${Math.random()}`}>
            {row.map((day) => (
              <Day
                arrayDate={arrayDate}
                day={day}
                isSummaryModal={isSummaryModal}
                key={`${day.$d}`}
                lineBlockedBySap={lineBlockedBySap}
                maxDate={maxDate}
                minDate={minDate}
                onClickDay={disabled || disabledEditStateCancelOrFinish ? () => {} : onClickDay}
                rowIdx={idx}
                variant=""
              />
            ))}
          </div>
        ))}
        {/* <Day variant="green - green-light - red - red-light - blue - blue-light" /> */}
      </div>
    </div>
  );
};

Month.propTypes = {
  month: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.objectOf(PropTypes.any),
      PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
    ])
  ).isRequired,
  showActions: PropTypes.bool.isRequired,
  showHeader: PropTypes.bool.isRequired,
  onClickDayBefore: PropTypes.func.isRequired,
  onClickNextDay: PropTypes.func.isRequired,
  arrayDate: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  onClickDay: PropTypes.func.isRequired,
  manualChange: PropTypes.bool.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  disabled: PropTypes.bool,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  isSummaryModal: PropTypes.bool,
  lineBlockedBySap: PropTypes.bool.isRequired
};

Month.defaultProps = {
  arrayDate: [],
  minDate: '',
  maxDate: '',
  disabled: false,
  isSummaryModal: false
};
export default Month;
